import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1179bbae"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "产品推荐", -1));
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "bg"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "无垠代码模糊测试", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "代码模糊测试"), /*#__PURE__*/_createTextVNode("可对编译后二进制文件进行动态检测，帮助开发、测试、安全人员快速发现、定位、验证目标工程的代码缺陷。")], -1));
const _hoisted_6 = {
  alt: "无垠代码模糊测试"
};
const _hoisted_7 = {
  class: "box"
};
const _hoisted_8 = {
  class: "bg"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "无垠协议模糊测试", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "协议模糊测试"), /*#__PURE__*/_createTextVNode("通过变异生成海量测试用例，可对被测协议的安全性与健壮性进行检测。")], -1));
const _hoisted_11 = {
  alt: "无垠协议模糊测试"
};
const _hoisted_12 = {
  class: "box"
};
const _hoisted_13 = {
  class: "bg"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "软件成分分析", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "软件成分分析（SCA）"), /*#__PURE__*/_createTextVNode("是一种用于管理开源组件应用安全的方法，可帮助开发团队快速跟踪和分析引入项目的开源组件中潜藏的安全隐患和许可证问。")], -1));
const _hoisted_16 = {
  alt: "软件成分分析"
};
const _hoisted_17 = {
  class: "box"
};
const _hoisted_18 = {
  class: "bg"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "静态应用安全测试", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "静态应用安全测试（SAST）"), /*#__PURE__*/_createTextVNode("在编译过程之前对代码进行安全扫描，发现并定位潜藏在代码中的安全缺陷。")], -1));
const _hoisted_21 = {
  alt: "静态应用安全测试"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_buttom_com = _resolveComponent("buttom-com");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'recommend-com active' : 'recommend-com')
  }, [_hoisted_1, _createVNode(_component_a_row, {
    class: "problem-class",
    justify: [24, 24]
  }, {
    default: _withCtx(() => [_createVNode(_component_a_col, {
      class: "class-box",
      md: 12,
      sm: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", {
        class: "buttom-box",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.jumpPage('/codeProduct.html', 1))
      }, [_createVNode(_component_buttom_com, {
        btnName: "了解更多"
      })]), _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/productsRecommended1.png')]])])])]),
      _: 1
    }), _createVNode(_component_a_col, {
      class: "class-box",
      md: 12,
      sm: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", {
        class: "buttom-box",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.jumpPage('/protocolProduct.html', 1))
      }, [_createVNode(_component_buttom_com, {
        btnName: "了解更多"
      })]), _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/productsRecommended2.png')]])])])]),
      _: 1
    }), _createVNode(_component_a_col, {
      class: "class-box",
      md: 12,
      sm: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", {
        class: "buttom-box",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.jumpPage('/bookDemoPage.html', 2))
      }, [_createVNode(_component_buttom_com, {
        btnName: "了解更多"
      })]), _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/productsRecommended3.png')]])])])]),
      _: 1
    }), _createVNode(_component_a_col, {
      class: "class-box",
      md: 12,
      sm: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _hoisted_20, _createElementVNode("div", {
        class: "buttom-box",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.jumpPage('/bookDemoPage.html', 2))
      }, [_createVNode(_component_buttom_com, {
        btnName: "了解更多"
      })]), _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/productsRecommended4.png')]])])])]),
      _: 1
    })]),
    _: 1
  })], 2);
}